var _circle, _circle2, _defs, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarktplatzOverview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    viewBox: "0 0 586.94 295.42",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 545.01,
    cy: 12.15,
    r: 8.87
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 576.94,
    cy: 57.53,
    r: 2.85
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1,.cls-2,.cls-3,.cls-4{stroke:#1d1d1b;stroke-miterlimit:10;}.cls-1,.cls-2,.cls-3,.cls-5{opacity:.75;}.cls-1,.cls-2,.cls-4{stroke-width:.5px;}.cls-1,.cls-4,.cls-6{fill:#dadada;}.cls-2,.cls-3{fill:none;}.cls-7{fill:#fff;}.cls-3{stroke-width:.75px;}.cls-8{fill:#f6b19a;}.cls-9{fill:#f5f5f5;}.cls-10{fill:#203c7e;}.cls-11{fill:#b22322;}.cls-12{fill:#f9ef81;}.cls-13{fill:#d53f3f;}.cls-5{fill:#1b1b1b;}\n    "))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 118.39,
    x2: 586.94,
    y1: 79.45,
    y2: 79.45
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 586.94,
    x2: 113.78,
    y1: 65.28,
    y2: 65.28
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 118.39,
    x2: 586.94,
    y1: 93.49,
    y2: 93.49
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 118.39,
    x2: 586.94,
    y1: 107.45,
    y2: 107.45
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 118.39,
    x2: 586.94,
    y1: 121.8,
    y2: 121.8
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 118.39,
    x2: 586.94,
    y1: 136.2,
    y2: 136.2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 118.39,
    x2: 586.94,
    y1: 150.38,
    y2: 150.38
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 113.78,
    x2: 113.78,
    y1: 24.29,
    y2: 295.42
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 113.78,
    x2: 586.94,
    y1: 271.64,
    y2: 271.64
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m3.59,22.75h30.3c.5,0,.91.41.91.91v.77H2.68v-.77c0-.5.41-.91.91-.91Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    height: 24.29,
    width: 586.94
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    height: 14.25,
    rx: 0.91,
    ry: 0.91,
    width: 81.45,
    x: 203.78,
    y: 5.02
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    height: 4.79,
    rx: 0.91,
    ry: 0.91,
    width: 22.69,
    x: 557.74,
    y: 9.75
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    height: 10.82,
    rx: 0.91,
    ry: 0.91,
    width: 10.82,
    x: 89.04,
    y: 6.28
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    height: 10.82,
    rx: 0.91,
    ry: 0.91,
    width: 10.82,
    x: 51.29,
    y: 6.28
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    height: 10.82,
    rx: 0.91,
    ry: 0.91,
    width: 10.82,
    x: 13.49,
    y: 6.28
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    height: 24.29,
    width: 86.11,
    x: 113.78
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    height: 11.42,
    rx: 0.91,
    ry: 0.91,
    width: 75.13,
    x: 119.63,
    y: 6.44
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    height: 11.85,
    rx: 0.91,
    ry: 0.91,
    width: 20.8,
    x: 121.86,
    y: 30.82
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    height: 6.07,
    rx: 0.91,
    ry: 0.91,
    width: 19.06,
    x: 171.44,
    y: 33.71
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    height: 11.85,
    rx: 0.91,
    ry: 0.91,
    width: 20.8,
    x: 144.26,
    y: 30.82
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    height: 13.05,
    width: 113.78,
    y: 68.69
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    height: 7.15,
    rx: 0.91,
    ry: 0.91,
    width: 30.02,
    x: 6.39,
    y: 32.95
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 5.4,
    rx: 0.91,
    ry: 0.91,
    width: 43.71,
    x: 6.39,
    y: 59.35
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 5.4,
    rx: 0.91,
    ry: 0.91,
    width: 42.89,
    x: 14.56,
    y: 85.38
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 32.44,
    x: 121.69,
    y: 70.04
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 43.4,
    x: 275.29,
    y: 70.04
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 26.16,
    x: 326.27,
    y: 70.04
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 26.16,
    x: 326.27,
    y: 83.95
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 26.16,
    x: 326.27,
    y: 97.85
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 26.16,
    x: 326.27,
    y: 112.15
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 26.16,
    x: 326.27,
    y: 126.44
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 26.16,
    x: 326.27,
    y: 140.58
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    height: 12.29,
    rx: 0.91,
    ry: 0.91,
    width: 70.68,
    x: 397.68,
    y: 277.89
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    height: 7.4,
    rx: 0.91,
    ry: 0.91,
    width: 8.65,
    x: 125.52,
    y: 280.22
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 21.65,
    x: 360.74,
    y: 140.58
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 19.33,
    x: 360.74,
    y: 126.44
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 19.33,
    x: 360.74,
    y: 112.15
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 19.33,
    x: 360.74,
    y: 97.85
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 21.36,
    x: 360.74,
    y: 83.95
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 21.36,
    x: 360.74,
    y: 70.04
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 13.44,
    x: 389.83,
    y: 70.04
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 13.44,
    x: 389.83,
    y: 83.95
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 13.44,
    x: 389.83,
    y: 97.85
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 13.44,
    x: 389.83,
    y: 112.15
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 13.44,
    x: 389.83,
    y: 126.22
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 13.44,
    x: 389.83,
    y: 140.58
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 20.49,
    x: 413.03,
    y: 140.58
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 21.07,
    x: 413.03,
    y: 126.22
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 20.49,
    x: 413.03,
    y: 112.15
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 21.36,
    x: 413.03,
    y: 97.85
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 17.73,
    x: 413.03,
    y: 83.95
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 17.73,
    x: 413.03,
    y: 70.04
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 3.13,
    x: 489.16,
    y: 70.04
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 3.13,
    x: 524.5,
    y: 70.04
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 8.65,
    x: 572.61,
    y: 70.04
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 8.65,
    x: 572.61,
    y: 83.93
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 8.65,
    x: 572.61,
    y: 97.82
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 8.65,
    x: 572.61,
    y: 112.22
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 8.65,
    x: 572.61,
    y: 126.44
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 8.65,
    x: 572.61,
    y: 140.65
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 3.13,
    x: 524.5,
    y: 83.93
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 3.13,
    x: 524.5,
    y: 98
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 3.13,
    x: 524.5,
    y: 112.22
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 3.13,
    x: 524.5,
    y: 126.44
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 3.13,
    x: 524.5,
    y: 140.65
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 3.13,
    x: 489.16,
    y: 83.93
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 3.13,
    x: 489.16,
    y: 98
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 3.13,
    x: 489.16,
    y: 112.07
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 3.13,
    x: 489.16,
    y: 126.36
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 3.13,
    x: 489.16,
    y: 140.65
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 5.33,
    x: 275.29,
    y: 83.95
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 36.85,
    x: 275.29,
    y: 97.85
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 43.4,
    x: 275.29,
    y: 112.15
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 36.85,
    x: 275.29,
    y: 126.22
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 8.49,
    x: 275.29,
    y: 140.58
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 27.58,
    x: 121.69,
    y: 83.95
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 15.91,
    x: 121.69,
    y: 97.85
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 33.58,
    x: 121.69,
    y: 112.15
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 23.6,
    x: 121.69,
    y: 126.22
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 31.95,
    x: 121.69,
    y: 140.58
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 21.15,
    x: 163.03,
    y: 140.58
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 21.15,
    x: 163.03,
    y: 126.22
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 21.15,
    x: 163.03,
    y: 112.15
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 21.15,
    x: 163.03,
    y: 97.85
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 21.15,
    x: 163.03,
    y: 83.95
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 21.15,
    x: 163.03,
    y: 70.04
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    height: 14.17,
    width: 32.94,
    x: 189.31,
    y: 65.28
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    height: 14.17,
    width: 32.94,
    x: 189.31,
    y: 79.45
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    height: 56.76,
    width: 32.94,
    x: 189.31,
    y: 93.62
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    height: 5.4,
    rx: 0.91,
    ry: 0.91,
    width: 36.74,
    x: 14.56,
    y: 72.36
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 5.4,
    rx: 0.91,
    ry: 0.91,
    width: 59.33,
    x: 14.56,
    y: 98.33
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 5.4,
    rx: 0.91,
    ry: 0.91,
    width: 45.65,
    x: 14.56,
    y: 111.56
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 5.4,
    rx: 0.91,
    ry: 0.91,
    width: 31.88,
    x: 13.49,
    y: 124.8
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 12.36,
    x: 199.3,
    y: 70.04
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 30.27,
    x: 226.07,
    y: 70.04
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 28.36,
    x: 226.07,
    y: 84.21
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 28.36,
    x: 226.07,
    y: 97.85
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 34.85,
    x: 226.07,
    y: 112.15
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 33.16,
    x: 226.07,
    y: 126.22
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 41.02,
    x: 226.07,
    y: 140.58
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 12.36,
    x: 199.6,
    y: 83.95
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 12.36,
    x: 199.6,
    y: 97.85
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 12.36,
    x: 199.6,
    y: 112.15
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 12.36,
    x: 199.6,
    y: 126.44
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 12.36,
    x: 199.6,
    y: 140.58
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    height: 16.4,
    width: 473.16,
    x: 113.78,
    y: 48.87
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 25.96,
    x: 121.86,
    y: 55.2
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 12.98,
    x: 163.03,
    y: 55.2
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 19.43,
    x: 193.11,
    y: 55.2
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 36,
    x: 226.07,
    y: 54.75
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 36.75,
    x: 275.29,
    y: 55.2
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 26.05,
    x: 326.61,
    y: 55.2
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 14.6,
    x: 360.74,
    y: 55.2
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 15.69,
    x: 389.83,
    y: 54.75
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 23.33,
    x: 413.39,
    y: 55.2
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 46.45,
    x: 444.96,
    y: 55.2
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 27.69,
    x: 499.94,
    y: 55.2
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 27.69,
    x: 535.29,
    y: 55.2
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 31.85,
    x: 402.07,
    y: 281.71
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 35.82,
    x: 480.61,
    y: 277.89
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 51.56,
    x: 528.07,
    y: 277.89
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 33.35,
    x: 528.07,
    y: 285.53
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    height: 4.65,
    rx: 0.91,
    ry: 0.91,
    width: 35.82,
    x: 480.61,
    y: 285.53
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    height: 7.4,
    rx: 0.91,
    ry: 0.91,
    width: 5.73,
    x: 145.78,
    y: 280.22
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarktplatzOverview);
export default __webpack_public_path__ + "static/media/marktplatz-overview.8a0b553de6f69122652fe1857b953c72.svg";
export { ForwardRef as ReactComponent };